import React, { PropsWithChildren } from 'react';
import { socket } from '../../constants/socket';
import { SocketContext } from './context';
import useUser from '../../hooks/global/useUser';

export function SocketProvider({ children }: PropsWithChildren) {
  const { user } = useUser();

  React.useEffect(() => {
    const initialize = () => {
      socket.connect();

      if (user?.business?.id) {
        socket.emit('register', { businessId: user.business.id });
      }
    };

    initialize();

    let attempt = 0;
    const onConnectError = () => {
      socket.io.opts.transports = ['polling', 'websocket'];
      const delay = Math.min(1000 * 2 ** attempt, 30000); // exponential backoff with a maximum delay of 30 seconds
      attempt += 1;
      setTimeout(() => {
        initialize();
      }, delay);
    };

    socket.on('connect_error', onConnectError);

    return () => {
      if (socket.connected) {
        socket.removeAllListeners();
        socket.disconnect();
      }
    };
  }, [user?.business?.id]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}
